import { context } from './context-service';

export enum PrivacyLaw {
	CCPA = 'ccpa',
	GDPR = 'gdpr',
	PIPL = 'pipl',
	LGPD = 'lgpd',
}

function isGdprConsentRequired(): boolean {
	const privacyLaw = context.get('options.privacyLaw');
	// We leave fallback for geoRequiresConsent in case if IE fails to set privacyLaw in fandomContext
	return privacyLaw ? privacyLaw === PrivacyLaw.GDPR : !!context.get('options.geoRequiresConsent');
}

function isOptedIn(optIn?: boolean): boolean {
	return !!(optIn ?? context.get('options.trackingOptIn'));
}

function isOptOutSale(optOutSale?: boolean): boolean {
	const isSubjectToCcpa = !!context.get('options.isSubjectToCcpa');

	if (isSubjectToCcpa) {
		return true;
	}

	return !!(optOutSale ?? context.get('options.optOutSale'));
}

export const trackingOptIn = {
	isGdprConsentRequired,
	isOptedIn,
	isOptOutSale,
};
